import router from 'next/router';

const getPreservedQueryParams = (customParams = {}) => {
  const { query } = router;
  const cleanCustomParams = { ...customParams };
  const forwardParams = {
    inside_app: 1,
    app_redirection: 1,
    source: 1,
    is_upgrade: 1,
    is_extend: 1,
    is_combo: 1,
    parent_subscription_uid: 1,
    combo_subscription_uid: 1,
    referral_code: 1,
    learner_details_uid: 1
  };
  const urlParamsToAdd = {};

  try {
    Object.keys(forwardParams).forEach((param) => {
      if (query[param]) {
        urlParamsToAdd[param] = query[param];
      }
    });

    const params = { ...urlParamsToAdd, ...cleanCustomParams };

    const queryParams = new URLSearchParams();
    Object.keys(params).forEach((p) => {
      if (params[p]) {
        queryParams.append(p, params[p]);
      }
    });
    const extraParams = queryParams.toString()
      ? `?${queryParams.toString()}`
      : '';
    return extraParams;
  } catch (error) {
    return '';
  }
};

export default getPreservedQueryParams;
